import {Component, Input, OnInit} from "@angular/core";

@Component({
    selector: "bi-blank-chart",
    templateUrl: "./blank-chart.component.html",
    styleUrls: ["./blank-chart.component.scss"]
})
export class BlankChartComponent implements OnInit {

    @Input() public height: number = 400;

    ngOnInit(): void {
    }
}
